/* @flow */

import * as React from 'react';

import {UppercaseLabel} from '../typography';

type Props = {
    label: string,
    content: string | React.Node,
    spacing?: number,
    isFullHeight?: boolean,
};

export function LabelWithContent(props: Props) {
    return (
        <div className={props.isFullHeight ? 'flex flex-dir-col full-height' : 'flex flex-dir-col'}>
            <div style={props.spacing ? {marginBottom: `${props.spacing}px`} : undefined}>
                <UppercaseLabel>{props.label}</UppercaseLabel>
            </div>
            {props.content}
        </div>
    );
}
